/**
 * Applies an optional auth display-name update.
 * `undefined` means no update, while `null` explicitly clears stale identity.
 */
export const resolveAuthDisplayName = (
  current: string | null,
  update: string | null | undefined,
): string | null => update === undefined ? current : update;
